import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { AzureDataLakeStoreFileCopySource } from 'app/model/pipeline/copysource/azure-data-lake-store.copysource';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { FileTypeSourceAdapter } from 'app/model/adapters/activities/copysource/file-type.source.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureDataLakeStoreFileCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        recursive: '*',
        maxConcurrentConnections: '*'
    }
})
export class AzureDataLakeStoreFileCopySourceAdapter extends CopySourceAdapter<
    AzureDataLakeStoreFileCopySource,
    Model.AzureDataLakeStoreSource
> {
    protected override async _toResource(
        copySource: AzureDataLakeStoreFileCopySource
    ): Promise<Model.AzureDataLakeStoreSource> {
        const result: Model.AzureDataLakeStoreSource = this.getCommonCopySourceProperties(
            copySource,
            'AzureDataLakeStoreSource'
        );
        FileTypeSourceAdapter.toSourceResource(copySource, result);
        return result;
    }

    protected override async _toModel(
        azureDataLakeStoreSource: Model.AzureDataLakeStoreSource,
        copyActivity: CopyActivity
    ): Promise<AzureDataLakeStoreFileCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            AzureDataLakeStoreFileCopySource.MODEL,
            azureDataLakeStoreSource,
            copyActivity
        ) as AzureDataLakeStoreFileCopySource;
        FileTypeSourceAdapter.toSourceModel(azureDataLakeStoreSource, result);
        return result;
    }
}
